var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-user-avatar-4035889",
    transform: "translate(425 412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_59",
    "data-name": "Layer 59",
    transform: "translate(-428 -415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49815",
    "data-name": "Path 49815",
    d: "M73,3a70,70,0,1,0,70,70A70,70,0,0,0,73,3Zm0,32.308A21.538,21.538,0,1,1,51.462,56.846,21.538,21.538,0,0,1,73,35.308Zm0,96.923a59.231,59.231,0,0,1-42-17.5c4.308-14.808,21.538-25.577,42-25.577s37.692,10.769,42,25.577a59.231,59.231,0,0,1-42,17.5Zm42-17.5",
    transform: "translate(0 0)",
    fill: "#c6e3f9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.d67cee03652088d6cff2d4a116e5d1c9.svg";
export { ForwardRef as ReactComponent };